import {
  CustomFieldAccessScopeEnum,
  CustomFieldEntityEnum,
  CustomFieldLifeCyclePolicyEnum,
  CustomFieldPermissionsEnum,
  CustomFieldPermissionsUiEnum,
  CustomFieldStatusEnum,
  CustomFieldTypeEnum,
  ICustomFieldMode,
  UserRoleEnum,
} from '@monetize/types/app';
import { ALL_ROLES } from './roles';

export const CUSTOM_FIELD_VISIBILITY_ROLES = ALL_ROLES.filter(
  (role) => role !== UserRoleEnum.REPORTING,
);

export const CUSTOM_FIELD_STATUS_DISPLAY: {
  [key in CustomFieldStatusEnum]: string;
} = {
  ACTIVE: 'Active',
};

export const CUSTOM_FIELD_PERMISSION_DISPLAY: {
  [key in CustomFieldPermissionsEnum]: string;
} = {
  READ: 'Read',
  WRITE: 'Write',
};

export const CUSTOM_FIELD_PERMISSION_UI_DISPLAY: {
  [key in CustomFieldPermissionsUiEnum]: string;
} = {
  EDITABLE: 'Editable',
  READ_ONLY: 'Read Only',
  HIDDEN: 'Hidden',
};

export const CUSTOM_FIELD_VISIBILITY_DISPLAY: {
  [key in CustomFieldPermissionsUiEnum | 'VARIES_BY_ROLE']: string;
} = {
  ...CUSTOM_FIELD_PERMISSION_UI_DISPLAY,
  VARIES_BY_ROLE: 'Varies by role',
};

export const CUSTOM_FIELD_ACCESS_SCOPE_OPTIONS: {
  value: CustomFieldAccessScopeEnum;
  title: string;
}[] = [
  { value: CustomFieldAccessScopeEnum.ALL_ROLES, title: 'All Roles' },
  { value: CustomFieldAccessScopeEnum.SPECIFIC_ROLES, title: 'Specific Roles' },
];

export const CUSTOM_FIELD_TYPE_DISPLAY: {
  [key in CustomFieldTypeEnum]: string;
} = {
  CHECKBOX: 'Checkbox',
  DATE: 'Date',
  DROPDOWN: 'Dropdown',
  MULTI_SELECT: 'Multi-select',
  NUMBER: 'Number',
  SINGLE_LINE_TEXT: 'Single Line Text',
};

export const CUSTOM_FIELD_ENTITY_DISPLAY: {
  [key in CustomFieldEntityEnum]: string;
} = {
  ACCOUNT: 'Account',
  BILL_GROUP: 'Bill Group',
  CONTACT: 'Contact',
  CONTRACT: 'Contract',
  CREDIT_NOTE: 'Credit Note',
  CREDIT: 'Credit',
  INVOICE: 'Invoice',
  LEGAL_ENTITY: 'Legal Entity',
  OFFERING: 'Offering',
  PRODUCT: 'Product',
  QUOTE: 'Quote',
  QUOTE_OFFERING_GROUP: 'Quote Offering Group',
  RATE: 'Rate',
  USAGE_EVENT: 'Usage Event',
};

/**
 * Usage event custom fields are restricted by billing-platform: only single line
 * text is accepted, and at most 50 active fields may exist. Mirrors
 * `CustomFieldType.isSupportedFor` / `MAX_ACTIVE_USAGE_EVENT_FIELDS` on the BE.
 */
export const USAGE_EVENT_CUSTOM_FIELD_ALLOWED_TYPES: CustomFieldTypeEnum[] = [
  CustomFieldTypeEnum.SINGLE_LINE_TEXT,
];
export const USAGE_EVENT_MAX_ACTIVE_CUSTOM_FIELDS = 50;

export const CUSTOM_FIELD_DATA_FORM_SPACING = {
  modal: {
    dividerTop: 0,
    dividerBottom: 4,
    gridTop: 4,
    gridBottom: 4,
    gridGap: 4,
  },
  accordion: {
    dividerTop: 4,
    dividerBottom: 4,
    gridTop: 4,
    gridBottom: 0,
    gridGap: 4,
  },
  drawer: {
    dividerTop: 4,
    dividerBottom: 4,
    gridTop: 0,
    gridBottom: 4,
    gridGap: 4,
  },
  page: {
    dividerTop: 0,
    dividerBottom: 0,
    gridTop: 0,
    gridBottom: 0,
    gridGap: 0,
  },
};

export const CUSTOM_FORM_CONTENT_DIVIDER_VIEW_MODES = new Set<ICustomFieldMode>(
  ['drawer'],
);

export const CUSTOM_FIELDS_LIFECYCLE_POLICY_OPTIONS = [
  {
    label: 'Retain on Amendment',
    value: CustomFieldLifeCyclePolicyEnum.RETAIN_ON_AMENDMENT_QUOTE,
  },
  {
    label: 'Retain on Renewal',
    value: CustomFieldLifeCyclePolicyEnum.RETAIN_ON_RENEWAL_QUOTE,
  },
  {
    label: 'Copy from Blueprint',
    value: CustomFieldLifeCyclePolicyEnum.COPY_FROM_BLUEPRINT,
  },
];
